module.exports = __webpack_public_path__ + "static/media/grey-download-invoice-icon.dde53fc5.svg";